<template>
  <div>
    <div v-if="!homePage" class="exhibition">

      <div class="main-container">
        <header class="exhibition-header">
          <h1 class="exhibition-title">{{ name }}</h1>
        </header>

        <div class="exhibition-gallery">
          <div
            v-for="(resource, index) in resources"
            :key="index"
            class="gallery-item"
            role="button"
            tabindex="0"
            @click="openLightbox(index)"
            @keydown.enter.prevent="openLightbox(index)"
          >
            <img :src="resourceUrls[index]" alt="Resource Image" class="gallery-image" />
            <div class="gallery-overlay">
              <h2 class="gallery-title">{{ resource.title }}</h2>
              <p class="gallery-description">{{ resource.description == 'undefined' ? '' : resource.description }}</p>
              <div class="cta">Cliquer pour agrandir</div>
            </div>
          </div>
        </div>

        <!-- Lightbox fullscreen -->
        <div v-if="lightboxOpen" class="lightbox" @click="closeLightbox">
          <div class="lightbox-content" @click.stop>
            <button class="lightbox-close" @click="closeLightbox" aria-label="Fermer">×</button>
            <div class="lightbox-media-wrap">
              <button class="nav prev" @click="prevLightbox" aria-label="Précédent">‹</button>
              <img v-if="isImage(currentResource?.name)" :src="currentUrl" alt="Resource Image" class="lightbox-media" />
              <video v-else-if="isVideo(currentResource?.name)" :src="currentUrl" controls class="lightbox-media"></video>
              <button class="nav next" @click="nextLightbox" aria-label="Suivant">›</button>
            </div>
            <div class="lightbox-meta">
              <h2 class="lightbox-title">{{ currentResource?.title }}</h2>
              <p class="lightbox-description">{{ (currentResource?.description === 'undefined' ? '' : currentResource?.description) }}</p>
              <a :href="currentUrl" :download="downloadName" class="download-link">Télécharger</a>
            </div>
          </div>
        </div>

        <footer class="exhibition-footer">
          <div>2021 ALPA TECHNOLOGIES</div>
          <div>Mentions Legales</div>
          <div>Fattu in Corsica</div>
        </footer>
      </div>
    </div>
    <div class="home-section" v-else>
      <component :is="selectedTemplate" :homeImage="homeImage" :exhibitIdProps="exhibitId" @exit="exitHomePage"></component>
    </div>
  </div>
</template>



<script>
import axios from "axios";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import Modele_2 from "../../components/Models/Modele_2.vue";
import Modele_3 from "../../components/Models/Modele_3.vue";
import Modele_1 from "../../components/Models/Modele_1.vue";
import Modele_4 from "../../components/Models/Modele_4.vue";
import Modele_5 from "../../components/Models/Modele_5.vue";
import Modele_6 from "../../components/Models/Modele_6.vue";
import Modele_7 from "../../components/Models/Modele_7.vue";

gsap.registerPlugin(ScrollTrigger);

export default {
  layout: "default",
  components: {
    Modele_2,
    Modele_3,
    Modele_1,
    Modele_4,
    Modele_5,
    Modele_6,
    Modele_7
  },
  props: [
    'homePageProps',
    'exhibitId'
  ],
  data() {
    return {
      id: this.$route.params.id ?? this.exhibitId,
      resources: [],
      name: "",
      userName: "",
      headImage: [],
      selectedTemplate: "",
      homePage: this.homePageProps ?? true,
      homeImage: {},
      resourceUrls: [],
      lightboxOpen: false,
      activeIndex: null
    };
  },
  methods: {
    getHeadImage(index) {
      let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${this.resources[index].name}`;
      return url;
    },
    openLightbox(index) {
      this.activeIndex = index;
      this.lightboxOpen = true;
      document.body.style.overflow = 'hidden';
    },
    closeLightbox() {
      this.lightboxOpen = false;
      this.activeIndex = null;
      document.body.style.overflow = '';
    },
    prevLightbox() {
      if (!this.resources.length) return;
      const i = this.activeIndex == null ? 0 : this.activeIndex;
      this.activeIndex = (i - 1 + this.resources.length) % this.resources.length;
    },
    nextLightbox() {
      if (!this.resources.length) return;
      const i = this.activeIndex == null ? 0 : this.activeIndex;
      this.activeIndex = (i + 1) % this.resources.length;
    },
    isImage(fileName) {
      return /\.(jpg|jpeg|png|gif|webp)$/i.test(fileName || '');
    },
    isVideo(fileName) {
      return /\.(mp4|mov|avi|webm|mkv)$/i.test(fileName || '');
    },
    async fetchResources() {
      if (this.resources.length === 0) {
        // Attendre que les ressources soient chargées si nécessaire
        await this.getResources();
      }

      // Utiliser Promise.all pour attendre que toutes les requêtes soient terminées
      const urls = this.resources.map(resource => `${process.env.VUE_APP_BASEURL}/s3Resource/${resource.name}`);
      try {
        const responses = await Promise.all(urls.map(url => axios.get(url)));
        this.resourceUrls = responses.map(response => response.data);
      } catch (error) {
        console.error("Erreur lors de la récupération des URLs des ressources", error);
      }
    },
    async getUserName() {
      let url = `${process.env.VUE_APP_BASEURL}/user/${this.id}`;
      let response = await axios.get(url);
      this.userName = response.data.name;
    },
    async getHomeImage() {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/exhibit_home/${this.$route.params.id ?? this.exhibitId}`;
        let response = await axios.get(url);
        this.homeImage = response.data[0];
      } catch (error) {
        console.log(error)
      }
    },
    async getModel() {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/model/${this.$route.params.id ?? this.exhibitId}`;
        let response = await axios.get(url);
        if (response.data.length > 0) {
          this.selectedTemplate = response.data[0].model;
          this.selectedTemplate = this.selectedTemplate.replace(/è/g, 'e').replace(/\s+/g, '_');
        }
      } catch (error) {
        console.log(error);
      }
    },
    exitHomePage() {
      this.homePage = false;
      setTimeout(() => {
        this.startAnimation();

      }, 2000)

    },
    async getExhibitName() {
      let url = `${process.env.VUE_APP_BASEURL}/exhibit/${this.id}`;
      let response = await axios.get(url);
      this.name = response.data.exhibit_name;
    },
    startAnimation() {
      var tl = gsap.timeline();
      //tl.set(".userName, #title", { x: "-140%" });
      tl.set(".headImage", { x: "140%", opacity: 0 });
      tl.to(".userName", { x: "0%" });
      tl.to("#title", { x: "0%" });
      tl.to(".headImage", { x: "0%", opacity: 1 });
      //tl.to(".footer", { visibility: "visible" });
      tl.to(".hr", {
        opacity: 1,
        duration: 0.2,
      });
      tl.fromTo(
        ".hr",
        {
          scaleX: 0,
          duration: 1,
        },
        {
          scaleX: 1,
          duration: 1,
        }
      );
      tl.to(".imageWrapper", {
        duration: 1,
        height: "100vh",
      });

      for (let i = 0; i < this.resources.length; i++) {
        tl.from(`.im${i}`, {
          scale: 3.3333,
          ease: "none",
        });
        tl.to(`.im${i}`, {
          scale: 0.9,
          autoAlpha: 1,
          scrollTrigger: {
            trigger: `.grid-container${i}`,
            start: "top top",
            end: "+=3300",
            pin: `.grid-container${i}`,
            scrub: true,

          },
        });
      }
    },
    async getResources() {
      let exhibitId = this.$route.params.id ?? this.exhibitId;

      try {
        // Obtenir les ressources de l'exposition
        let resourcesUrl = `${process.env.VUE_APP_BASEURL}/resources`;
        let response = await axios.post(resourcesUrl, { exhibitId });
        let allResources = response.data;

        // Obtenir les resource_id de gallery_resource
        let galleryUrl = `${process.env.VUE_APP_BASEURL}/galleryResources/${exhibitId}`;
        let galleryResponse = await axios.get(galleryUrl);
        let galleryResourceIds = galleryResponse.data.map(res => res.resource_id);

        // Filtrer les ressources pour ne garder que celles présentes dans gallery_resource
        this.resources = allResources.filter(resource =>
          galleryResourceIds.includes(resource.id)
        );
      } catch (error) {
        console.error("Error fetching resources:", error);
      }
    }
    ,
  },
  computed: {
    currentResource() {
      if (this.activeIndex == null) return null;
      return this.resources[this.activeIndex] || null;
    },
    currentUrl() {
      if (this.activeIndex == null) return '';
      return this.resourceUrls[this.activeIndex] || '';
    },
    downloadName() {
      const r = this.currentResource;
      return r ? (r.title ? `${r.title}.jpg` : 'resource.jpg') : 'resource.jpg';
    }
  },

  created() {
    this.getHomeImage();
    this.getResources();
    this.fetchResources();
    this.getExhibitName();
    this.getUserName();
    this.getModel();
  },
};
</script>

<style scoped>
.main-container {
  font-family: 'Roboto', sans-serif;
  color: #333;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.exhibition {
  text-align: center;
}

.exhibition-header {
  margin-bottom: 40px;
}

.exhibition-title {
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.exhibition-subtitle {
  font-size: 1.5rem;
  color: #666;
}

.exhibition-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 26px;
}

.gallery-item {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);
  transition: transform 0.35s ease, box-shadow .35s ease, filter .35s ease;
  cursor: zoom-in;
  --rot: 0deg;
  transform: rotate(var(--rot));
}
.gallery-item:nth-child(6n+1){ --rot: -2.2deg; }
.gallery-item:nth-child(6n+2){ --rot: 1.6deg; }
.gallery-item:nth-child(6n+3){ --rot: -1.1deg; }
.gallery-item:nth-child(6n+4){ --rot: 2deg; }
.gallery-item:nth-child(6n+5){ --rot: -1.6deg; }

.gallery-item:hover {
  transform: rotate(0deg) translateY(-6px);
  box-shadow: 0 20px 40px rgba(0,0,0,.25);
  filter: saturate(1.1);
}
.gallery-item::before{
  content: '';
  position: absolute;
  inset: -2px;
  border-radius: 18px;
  background: conic-gradient(#7c3aed, #22d3ee, #7c3aed);
  z-index: 0;
  animation: spin 8s linear infinite;
}
.gallery-item::after{
  content: '';
  position: absolute;
  inset: 2px;
  border-radius: 14px;
  background: #0a0f1e;
  z-index: 1;
}
.gallery-image, .gallery-overlay{ position: relative; z-index: 2; }
@keyframes spin { to { transform: rotate(360deg); } }

.gallery-image {
  width: 100%;
  height: 100%;
  aspect-ratio: 4/3;
  object-fit: cover;
  transition: transform 0.45s ease;
}

.gallery-item:hover .gallery-image {
  transform: scale(1.1);
}

.gallery-overlay {
  position: absolute;
  inset: auto 0 0 0;
  background: linear-gradient(to top, rgba(0,0,0,.85) 0%, rgba(0,0,0,.0) 75%);
  color: white;
  padding: 16px;
  transform: translateY(0);
  opacity: 0;
  transition: opacity .35s ease;
}

.gallery-item:hover .gallery-overlay {
  opacity: 1;
}

.gallery-overlay .cta {
  margin-top: 8px;
  font-size: .85rem;
  opacity: .9;
}

.gallery-title {
  font-size: 1.125rem;
  font-weight: 700;
  margin: 0 0 6px;
}

.gallery-description {
  font-size: .95rem;
  line-height: 1.5;
}

.exhibition-footer {
  margin-top: 50px;
  text-align: center;
  font-size: 1rem;
  color: #666;
}

.exhibition-footer div {
  margin-top: 10px;
}
/* Lightbox */
.lightbox {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.85);
  display: grid;
  place-items: center;
  z-index: 9999;
  padding: 16px;
}
.lightbox-content {
  max-width: 1200px;
  width: 100%;
  background: #0b1020;
  color: #f8fafc;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 30px 80px rgba(0,0,0,.45);
}
.lightbox-close {
  position: absolute;
  top: 18px;
  right: 22px;
  width: 40px;
  height: 40px;
  border: none;
  background: rgba(255,255,255,.1);
  color: #fff;
  font-size: 28px;
  border-radius: 50%;
  cursor: pointer;
}
.lightbox-media-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  background: #0f172a;
}
.lightbox-media-wrap .nav{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 42px;
  height: 42px;
  border: none;
  border-radius: 50%;
  background: rgba(255,255,255,.12);
  color: #fff;
  font-size: 24px;
  cursor: pointer;
}
.lightbox-media-wrap .prev{ left: 12px; }
.lightbox-media-wrap .next{ right: 12px; }
.lightbox-media {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.lightbox-meta {
  padding: 16px 20px 22px;
}
.lightbox-title {
  margin: 0 0 8px;
  font-size: 1.25rem;
}
.lightbox-description {
  margin: 0 0 12px;
  opacity: .9;
}
.download-link {
  display: inline-block;
  padding: 10px 14px;
  background: #334155;
  color: #fff;
  border-radius: 10px;
  text-decoration: none;
}
</style>
